import AccountDetailsUserInfo from './AccountDetailsUserInfo'
export default AccountDetailsUserInfo
